/* eslint-disable no-throw-literal */
import "moment/locale/he";
import moment from "moment/min/moment-with-locales";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import clubAPI from "../api/clubAPI";
import swalDialog from "../helpers/swalErrorPopup";
import WomanPilates from "../img/woman_sport.png";
import WOWVenue from "../img/WOWVenue.png";
import NotificationPopup from "../shared/notificationPopup";
import Popup from "../shared/popup";
import { PoweredBy } from "../shared/PoweredBy";
import { headerCustomDisplaying, headerDisplaying, isLoadChanger, setCustomHeaderText } from "../store/mainSlice";
import {
  activeMultipleEntryPassesDetailsSelector,
  hasActiveMultipleEntryPassSelector,
} from "../store/multipleEntryPassSlice";
import { isPartnerClalit } from "../store/partnerStore";

const SelectRoomByDate = () => {
  const DATE_PICKER_RANGE = 14;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isClalit = useSelector(isPartnerClalit);
  const userParams = useSelector((state) => state.userSlice.userData);
  const isHaveCard = useSelector((state) => state.userSlice.isHaveCreditCard);
  const mainUserParams = useSelector((state) => state.userSlice.mainUserData);
  const cityAndClubs = useSelector((state) => state.appParamSlice.allAppParams);
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [clubLessonList, setClubLessonList] = useState(null);
  const [selectedDate, setSelectedDate] = useState(moment().format("DD.MM.YYYY"));
  const [selectedLesson, setSelectedLesson] = useState({});
  const isLoad = useSelector((state) => state.mainSlice.isLoad);

  const hasActiveMultipleEntryPass = useSelector(hasActiveMultipleEntryPassSelector);
  const multipleEntryPassDetails = useSelector(activeMultipleEntryPassesDetailsSelector);

  useEffect(() => {
    const fetch = async () => {
      try {
        dispatch(isLoadChanger(true));
        const param = await clubAPI.getClubLessonList({
          clubID: location.state.clubId,
          token: mainUserParams.Token,
          id: mainUserParams.ID,
          phone: mainUserParams.Phone,
        });
        if (param.data.Error !== 0) {
          throw {
            code: param.data.Error,
            mess: param.data.Message,
          };
        }
        dispatch(isLoadChanger(false));
        setClubLessonList(JSON.parse(param.data.Data));
      } catch (err) {
        dispatch(isLoadChanger(false));
        swalDialog(err);
      }
    };
    if (userParams && Object.keys(userParams).length > 0) {
      fetch();
    }
  }, [userParams]);

  useEffect(() => {
    dispatch(headerDisplaying(true));
    dispatch(headerCustomDisplaying(true));
    dispatch(setCustomHeaderText(t("BOOK_LESSON_ACTIVITY")));

    moment.locale("he");
    return () => {
      dispatch(headerDisplaying(true));
      dispatch(headerCustomDisplaying(false));
      dispatch(setCustomHeaderText(""));
    };
  }, [t]);

  const [openNotificationPopup, setOpenNotificationPopup] = useState(false);

  return (
    <div className="select-room-by-date-container">
      {!isLoad && (
        <div
          style={
            !clubLessonList || clubLessonList.filter((el) => el.LessonEndDate.split(" ")[0] === selectedDate).length > 0
              ? { flexGrow: 1 }
              : { flexGrow: 1, display: "flex", flexDirection: "column" }
          }
        >
          <img src={isClalit ? WomanPilates : WOWVenue} alt="" className="select-room-by-date-img" />
          <div
            className="select-room-by-date-content-container"
            style={
              !clubLessonList ||
              clubLessonList.filter((el) => el.LessonEndDate.split(" ")[0] === selectedDate).length > 0
                ? {}
                : { flex: 1, display: "flex", flexDirection: "column" }
            }
          >
            <div
              className="select-room-by-date-selector"
              style={{
                display: "flex",
                overflowX: "auto",
                gap: "8px",
                paddingBottom: "8px",
                direction: "rtl",
              }}
            >
              {[...Array(DATE_PICKER_RANGE)].map((_, offset) => {
                const m = moment().add(offset, "days");
                const date = m.format("DD.MM.YYYY");
                const day = m.format("DD");
                const month = m.format("M");

                return (
                  <div
                    key={date}
                    className={`select-room-by-date-selector-elem${
                      selectedDate === date ? " selected" : ""
                    } date-scroll-item`}
                    onClick={() => setSelectedDate(date)}
                  >
                    <p>{`${t("DAY")} ${m.format("ddd")}`}</p>
                    <p>{`${day}/${month}`}</p>
                  </div>
                );
              })}
            </div>

            <div
              className="select-room-by-date-main-elements"
              style={
                !clubLessonList ||
                clubLessonList.filter((el) => el.LessonEndDate.split(" ")[0] === selectedDate).length > 0
                  ? {}
                  : { flex: 1 }
              }
            >
              {!clubLessonList ? (
                ""
              ) : clubLessonList.filter((el) => el.LessonEndDate.split(" ")[0] === selectedDate).length > 0 ? (
                clubLessonList
                  .filter((el) => el.LessonEndDate.split(" ")[0] === selectedDate)
                  .map((el) => (
                    <div
                      className="select-room-by-date-main-element"
                      style={el?.IsReadOnly ? { justifyContent: "end", position: "relative" } : {}}
                    >
                      {(el?.IsReadOnly && el?.SlotsAvailable > 0) || el?.IsUserBooked ? (
                        <div
                          style={{
                            width: "100%",
                            height: "100%",
                            position: "absolute",
                            top: 0,
                            left: 0,
                            backgroundColor: "rgba(0, 0, 0, 0.2)",
                          }}
                        />
                      ) : (
                        ""
                      )}
                      {(el?.IsReadOnly && el?.SlotsAvailable > 0) || el?.IsUserBooked ? (
                        ""
                      ) : (
                        <div className="select-room-by-date-main-element-btn-block">
                          {el.SlotsAvailable > 0 ? (
                            <div style={{ display: "flex", gap: "5px" }}>
                              <p className="select-room-availible">{t("AVAILABLE_SPOTS")}</p>
                              <p className="select-room-availible">{el.SlotsAvailable}</p>
                            </div>
                          ) : (
                            <p className="select-room-not-availible">{t("NO_SPOTS_LEFT")}</p>
                          )}

                          <button
                            className="select-room-by-date-main-element-btn-coloured"
                            onClick={() => {
                              if (el.SlotsAvailable > 0) {
                                setSelectedLesson(el);
                                navigate("/summary", {
                                  state: {
                                    clubId: location.state.clubId,
                                    clubName: location.state.clubName,
                                    dateFull: el.LessonStartDate,
                                    type: location.state.type,
                                    selectedLesson: el,
                                  },
                                });
                              }
                            }}
                            disabled={el.SlotsAvailable === 0}
                            style={{
                              backgroundColor: el.SlotsAvailable > 0 ? "var(--darkblue)" : "#b3bbd1",
                              border: 0 > 0 ? "var(--darkblue)" : "#b3bbd1",
                            }}
                          >
                            {t("BOOK")}
                          </button>
                        </div>
                      )}
                      <div className="select-room-by-date-main-element-text-container">
                        <p>{el.LessonStartDate.split(" ")[1]}</p>
                        <p className="select-room-lesson-name">{el.LessonName}</p>
                        <p className="select-room-coach-name">{el.CoachName}</p>
                      </div>
                    </div>
                  ))
              ) : (
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      margin: "120px auto 0",
                      textAlign: "center",
                      display: "flex",
                      gap: 8,
                      flexDirection: "column",
                    }}
                  >
                    <p
                      style={{
                        fontSize: 26,
                        lineHeight: "24px",
                        color: "rgba(27, 41, 107, 1)",
                        fontWeight: "700",
                      }}
                    >
                      {t("NO_LESSONS_TODAY")}
                    </p>
                    <p
                      style={{
                        fontSize: 18,
                        lineHeight: "22px",
                        color: "rgba(27, 41, 107, 1)",
                        fontWeight: "400",
                      }}
                    >
                      {t("CHECK_OTHER_DAYS")}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {isClalit && (
        <div
          style={{
            position: "sticky",
            bottom: 0,
          }}
        >
          <PoweredBy />
        </div>
      )}

      <Popup
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        headerText={t("ORDER_CONFIRMATION")}
        bodyText={
          selectedLesson && Object.keys(selectedLesson).length > 0
            ? [
                `${selectedLesson.LessonName} ${t("LESSON_DETAILS.FOR_CLUB")} `,
                `${selectedLesson.LessonStartDate.split(" ")[1]} ${t("LESSON_DETAILS.AT_TIME")} ${
                  selectedLesson.LessonStartDate.split(" ")[0]
                }, ${t("LESSON_DETAILS.ON_DATE")}`,
              ]
            : []
        }
        confirmBtnText={t("CONFIRMATION_BOOK")}
        cancelBtnText={t("CONFIRMATION_CANCEL")}
        onConfirm={
          isHaveCard || (isClalit && hasActiveMultipleEntryPass && multipleEntryPassDetails.NumberOfEntries < 4)
            ? async () => {
                try {
                  const selectedClub = cityAndClubs.ClubList.find((el) => el.RecordID === location.state.clubId);
                  dispatch(isLoadChanger(true));
                  const result = await clubAPI.createWebClubOrder({
                    token: mainUserParams.Token,
                    id: mainUserParams.ID,
                    phone: mainUserParams.Phone,
                    cardNumber: userParams.CardNumber,
                    source: isClalit ? null : mainUserParams.Source ?? null,
                    terminalID: selectedClub.TerminalID,
                    binType: selectedClub.BinType,
                    clubID: selectedClub.RecordID,
                    preOrderDate: selectedLesson.LessonStartDate,
                    isRbox:
                      selectedClub.IsStudioRbox ||
                      selectedClub.IsStudioFizikal ||
                      selectedClub.IsStudioLeap ||
                      selectedClub.IsStudioBoostapp,
                    rboxLessonID: selectedLesson.RboxLessonID,
                    lessonName: selectedLesson.LessonName,
                    lessonStartDate: selectedLesson.LessonStartDate,
                    lessonEndDate: selectedLesson.LessonEndDate,
                    coachName: selectedLesson.CoachName,
                    cancelationTime: selectedLesson.CancelationTime,
                    isCancelAllow: selectedLesson.IsCancelAllow,
                  });
                  if (result.data.Error) {
                    dispatch(isLoadChanger(false));
                    throw {
                      code: result.data.Error,
                      mess: result.data.Message,
                    };
                  }
                  dispatch(isLoadChanger(false));
                  navigate("/orderConfirmation", {
                    state: {
                      date: moment().format("DD-MM-YYYY"),
                      hours: moment().format("HH"),
                      minutes: moment().format("mm"),
                      clubId: selectedClub.RecordID,
                      clubName: selectedClub.Name,
                    },
                  });
                } catch (err) {
                  setOpenNotificationPopup(true);
                }
              }
            : () => {
                navigate("/addCard", {
                  state: {
                    date: moment().format("DD-MM-YYYY"),
                    hours: moment().format("HH"),
                    minutes: moment().format("mm"),
                    route: "orderConfirmation",
                    clubId: location.state.clubId,
                    clubName: location.state.clubName,
                  },
                });
              }
        }
      />

      <NotificationPopup
        isOpen={openNotificationPopup}
        setIsOpen={setOpenNotificationPopup}
        bodyTopText={t("FUTURE_ACTIVITY_MESSAGE_TITLE")}
        bodyText={t("FUTURE_ACTIVITY_MESSAGE_TEXT")}
        btnText={t("CLOSE")}
      />
    </div>
  );
};

export default SelectRoomByDate;
